export class TablePosition {
  public constructor(private pos: number = -1) {}

  public current(): number {
    return this.pos;
  }

  public next(): number {
    this.pos++;

    return this.pos;
  }

  public skip(value: number = 1): number {
    if (value <= 0) throw new Error(`${this.constructor.name}.skip(${value}) value must be > 0`);
    this.pos = this.pos + value;

    return this.pos;
  }

  public set(position: number): void {
    this.pos = position;
  }
}
